/**
 * @fileoverview Agent definition for portrait-image-prompt-creator-v2.
 *
 * This agent takes character details and creates a rich, artistic portrait
 * prompt for an image generation model, with a photo studio aesthetic.
 *
 * @category visuals.prompts.characters
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'portrait-image-prompt-creator-v2',
  kind: 'primitive',
  name: 'Portrait Image Prompt Creator',
  description: 'Takes character details and creates a rich, artistic portrait prompt for an image generation model.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.prompts.characters',
    usedBy: [
      'use-portrait-image-prompt-creator-v2.ts',
      'use-portrait-generation-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-image-prompt-creator-v2',
      'portrait-image-creator-fal-v2',
    ],
  },
};
